import React, { useContext, useState, useEffect, useRef } from "react";
import { Button, Modal, Select, Space, Spin, Table, Tooltip } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import { ImageView } from "../image/imageView";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
import { ViewPrevetiveDetails } from "../viewPreventive/viewPreventive";
import { LanguageContext } from "../../context/LanguageContext";
import { professionalAction } from "../../_actions";
import { EditOutlined, EyeOutlined, SettingOutlined } from "@ant-design/icons";
const { Option } = Select;

const FilterList = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [name, setName] = useState();
  const [showGunaDetails, setshowGunaDetails] = useState(false);
  const [gunaLoading, setGunaLoading] = useState(false);
  const [preventiveLoading, setPreventiveLoading] = useState(false);
  const [preventiveAction, setPreventiveAction] = useState([]);
  const [selectOption, setSelectOption] = useState({});

  const { t } = useContext(LanguageContext);

  const handleMobile = (record) => {
    props.handleMultipleMobile(record);
  };
  const handleEditForm = (id) => {
    props.onEditAccusedForm(id);
  };
  const handlePreventiveViewForm = (data) => {
    props.onPreventiveViewAccusedForm(data);
  };

  const handleNCrNumberViewForm = (data) => {
    props.onNCRViewAccusedForm(data);
  };

  const handelSelectOption = (value, record) => {
    if (value === "preventive") {
      handlePreventiveViewForm(record.id);
    }

    if (value === "crNumber") {
      handleNCrNumberViewForm(record.id);
    }
    if (value == "mobile") {
      handleMobile(record.id);
    }

    // reset dropdown back to "select"
    setSelectOption((prev) => ({
      ...prev,
      [record.id]: "select",
    }));
  };

  const getPreventiveInfo = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          setPreventiveAction(data);
        });
    });
  };

  useEffect(() => {
    getPreventiveInfo();
  }, []);

  const showGunaViewModel = () => {
    setshowGunaDetails(true);
  };
  const closeGunaViewModel = () => {
    setshowGunaDetails(false);
  };
  const onGunaForm = (data) => {
    showGunaViewModel();
    if (data) {
      setGunaLoading(true);
      props.dispatch({
        type: "GET_CRIMINALS_BY_ID_SUCCESS",
        criminalViewList: {},
      });
      props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  const [id, setId] = useState();
  const getFirstPhoto = (photo) => {
    if (!photo) return "";
    if (Array.isArray(photo)) {
      const first = photo.find((item) => item && String(item).trim());
      return first ? String(first).trim() : "";
    }
    if (typeof photo === "string") {
      return photo.split(",")[0].trim();
    }
    return "";
  };
  const openImageModal = (img, name, id) => {
    setImageOpen(true);
    setSelectedImage(img);
    setName(name);
    setId(id);
  };

  const [showPreventiveDetails, setShowPreventiveDetails] = useState(false);
  const showpreventiveViewModel = () => {
    setShowPreventiveDetails(true);
  };
  const closepreventiveViewModel = () => {
    setShowPreventiveDetails(false);
  };
  const onpreventiveForm = (data) => {
    showpreventiveViewModel();
    if (data) {
      setPreventiveLoading(true);
      props.dispatch({
        type: "GET_CRIMINALS_BY_ID_SUCCESS",
        criminalViewList: {},
      });
      props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      preventiveLoading &&
      props.professionals?.criminalViewList &&
      Object.keys(props.professionals.criminalViewList).length > 0
    ) {
      setPreventiveLoading(false);
    }
  }, [props.professionals?.criminalViewList]);
  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
    setName(null);
  };
  const handleViewForm = (data) => {
    props.onViewAccusedDetails(data);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page - 1);
    setPageSize(size);
  };
  console.log("props filter", props);

  const preventiveColumn = {
    title: t("preventive_action"),
    key: "preventive_recordss",
    filters: [
      { text: t("completed"), value: "completed" },
      { text: t("ongoing"), value: "ongoing" },
      { text: "-", value: "-" },
    ],
    onFilter: (value, record) => {
      const currentDate = moment();

      if (
        !record.preventive_records ||
        record.preventive_records.length === 0 ||
        record.preventive_records[0].date_from != null
      ) {
        return value === "-";
      }

      const firstRecord = record.preventive_records[0];
      const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

      const status = firstRecord.date_to
        ? dateTo.isBefore(currentDate, "day")
          ? "completed"
          : "ongoing"
        : "-";

      return status === value;
    },
    sorter: (a, b) => {
      const order = { completed: 0, ongoing: 1, "-": 2 };

      const getStatus = (record) => {
        const currentDate = moment();
        if (
          !record.preventive_records ||
          record.preventive_records.length === 0 ||
          record.preventive_records[0].date_from != null
        ) {
          return "-";
        }

        const firstRecord = record.preventive_records[0];
        const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

        return firstRecord.date_to
          ? dateTo.isBefore(currentDate, "day")
            ? "completed"
            : "ongoing"
          : "-";
      };

      return order[getStatus(a)] - order[getStatus(b)];
    },
    render: (text, record) => {
      const currentDate = moment();

      if (
        !record.preventive_records ||
        record.preventive_records.length === 0
      ) {
        return <div className="action-links-responsive">-</div>;
      }

      const firstRecord = record.preventive_records[0];
      const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

      const status = firstRecord.date_to
        ? dateTo.isBefore(currentDate, "day")
          ? t("completed")
          : t("ongoing")
        : "-";

      return (
        <div className="action-links-responsive">
          <Button
            type="text"
            size="small"
            className="action-link update-link"
            disabled={status === "-"}
            onClick={() => onpreventiveForm(record.id)}
          >
            {status}
          </Button>
        </div>
      );
    },
  };

  let columns = [
    {
      title: t("sr.no"),
      key: "index",
      render: (_, __, index) => currentPage * pageSize + index + 1,
    },
    {
      title: t("name"),
      key: "name",
      render: (text, record) => (
        <Space size="middle" title={record.id} style={{ maxWidth: 300 }}>
          {record.name}
        </Space>
      ),
    },
    {
      title: t("address"),
      key: "address",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.address ? record.address : ""}
        </Space>
      ),
    },
    {
      title: t("age"),
      key: "age",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.age}
        </Space>
      ),
    },
    {
      title: t("phone_no"),
      key: "phone",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.mobileNumber}
        </Space>
      ),
    },
    {
      title: t("accused_police_station"),
      key: "phone",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record.districtName}
        </Space>
      ),
    },
    {
      title: t("total_crimes"),
      key: "gunhaCount",
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
            onClick={() => {
              onGunaForm(record.id);
            }}
          >
            {record.gunhaCount || record.totalCrimeCount || "-"}
          </Button>
        </div>
      ),
    },
    ...(props?.filter ? [preventiveColumn] : []),
    // {
    //   title: t("preventive_action"),
    //   key: "preventive_recordss",
    //   filters: [
    //     { text: t("completed"), value: "completed" },
    //     { text: t("ongoing"), value: "ongoing" },
    //     { text: "-", value: "-" },
    //   ],
    //   onFilter: (value, record) => {
    //     const currentDate = moment();

    //     if (
    //       !record.preventive_records ||
    //       record.preventive_records.length === 0 ||
    //       record.preventive_records[0].date_from != null
    //     ) {
    //       return value === "-";
    //     }

    //     const firstRecord = record.preventive_records[0];
    //     const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

    //     const status = firstRecord.date_to
    //       ? dateTo.isBefore(currentDate, "day")
    //         ? "completed"
    //         : "ongoing"
    //       : "-";

    //     return status === value;
    //   },
    //   sorter: (a, b) => {
    //     const currentDate = moment();

    //     const getStatus = (record) => {
    //       if (
    //         !record.preventive_records ||
    //         record.preventive_records.length === 0 ||
    //         record.preventive_records[0].date_from != null
    //       ) {
    //         return "-";
    //       }

    //       const firstRecord = record.preventive_records[0];
    //       const dateTo = firstRecord.date_to
    //         ? moment(firstRecord.date_to)
    //         : null;

    //       return firstRecord.date_to
    //         ? dateTo.isBefore(currentDate, "day")
    //           ? "completed"
    //           : "ongoing"
    //         : "-";
    //     };

    //     const statusA = getStatus(a);
    //     const statusB = getStatus(b);

    //     // sorting order: completed -> ongoing -> "-"
    //     const order = { completed: 0, ongoing: 1, "-": 2 };

    //     return order[statusA] - order[statusB];
    //   },
    //   render: (text, record) => {
    //     const currentDate = moment();

    //     if (
    //       !record.preventive_records ||
    //       record.preventive_records.length === 0
    //     ) {
    //       return <div className="action-links-responsive">-</div>;
    //     }

    //     const firstRecord = record.preventive_records[0];
    //     const dateTo = firstRecord.date_to ? moment(firstRecord.date_to) : null;

    //     const status = firstRecord.date_to
    //       ? dateTo.isBefore(currentDate, "day")
    //         ? t("completed")
    //         : t("ongoing")
    //       : "-";

    //     return (
    //       <div className="action-links-responsive">
    //         <Button
    //           type="text"
    //           size="small"
    //           className="action-link update-link"
    //           disabled={status === "-"}
    //           onClick={() => onpreventiveForm(record.id)}
    //         >
    //           {status}
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
    {
      title: t("photo"),
      key: "photo",
      render: (text, record) => {
        const photo =
          props.role === "2" && props.is_search === true
            ? getFirstPhoto(record?.image)
            : getFirstPhoto(record?.photo);

        return (
          <Space size="middle">
            {photo ? (
              <img
                style={{ width: 50, height: 50, objectFit: "cover" }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" + photo
                }
                alt={record.name || ""}
                onClick={() =>
                  openImageModal(photo, record.name, record.masterId)
                }
              ></img>
            ) : (
              t("no")
            )}
          </Space>
        );
      },
    },
    {
      title: t("action"),
      key: "action",
      render: (text, record) => (
        console.log("record", record),
        (
          <div className="gov-action-wrapper">
            <Space size="middle">
              {props.is_search === true && (
                <Tooltip title="Update Record">
                  <Button
                    type="primary"
                    icon={<EditOutlined />}
                    className="gov-btn-update"
                    onClick={() => handleEditForm(record)}
                  >
                    {t("update")}
                  </Button>
                </Tooltip>
              )}

              {props.role === "2" && props.is_search && (
                <Select
                  className="gov-select"
                  onChange={(value) => handelSelectOption(value, record)}
                >
                  <Select.Option value="select" disabled>
                    निवडा
                  </Select.Option>
                  <Select.Option value="preventive">
                    {t("preventive")}
                  </Select.Option>
                  <Select.Option value="crNumber">
                    {t("crNumber")}
                  </Select.Option>
                  <Select.Option value="mobile">
                    <span style={{ whiteSpace: "normal" }}>
                      {t("multiple_mobile")}
                    </span>
                  </Select.Option>
                </Select>
              )}
              <Tooltip title="View Details">
                <Button
                  icon={<EyeOutlined />}
                  className="gov-btn-view"
                  onClick={() => {
                    handleViewForm(record.id);
                  }}
                >
                  {t("view1")}
                </Button>
              </Tooltip>
            </Space>
          </div>
        )
      ),
    },
  ];
  //  const actionColIndex = columns.findIndex((col) => col.key === "photo");

  //  if (props?.advancedFilterTitle !== "") {
  //    const headingNamesCol = {
  //      title:
  //        props?.advancedFilterTitle === "लघु शीर्षक" ||
  //        props?.advancedFilterTitle === "मोडस"
  //          ? t("sub_title")
  //          : t("title"),
  //      key: "headingNames",
  //      render: (text, record) => {
  //        const values =
  //          props?.advancedFilterTitle === "मोडस"
  //            ? record?.subheadings
  //            : props?.advancedFilterTitle === "लघु शीर्षक"
  //            ? record?.subheadings
  //            : record?.crime_titles || [];
  //        const displayValue =
  //          Array.isArray(values) && values.length > 0 ? values[0] : "";
  //        const fullValue =
  //          Array.isArray(values) && values.length > 0 ? values.join(", ") : "";

  //        return (
  //          <Space
  //            size="middle"
  //            style={{
  //              maxWidth: 200,
  //              overflow: "hidden",
  //              textOverflow: "ellipsis",
  //              whiteSpace: "nowrap",
  //              cursor: "pointer",
  //            }}
  //          >
  //            {/* {displayValue} */}
  //            {record.crime_titles}
  //          </Space>
  //        );
  //      },
  //    };

  //    columns.splice(actionColIndex, 0, headingNamesCol);
  //  }

  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      gunaLoading &&
      props.professionals?.criminalViewList &&
      Object.keys(props.professionals.criminalViewList).length > 0
    ) {
      setGunaLoading(false);
    }
  }, [props.professionals?.criminalViewList]);
  return (
    <>
      <Table
        bordered
        columns={columns}
        dataSource={props?.data}
        loading={props?.loading}
        pagination={{
          current: currentPage + 1,
          pageSize: pageSize,
          total: props?.data?.length || 0,
          onChange: handlePageChange,
        }}
        rowKey={(record) => record.id || record.key}
        rowClassName={() => "govt-table-row"}
      />

      {imageOpen && (
        <ImageView
          imageOpen={imageOpen}
          name={name}
          imageUrl={
            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" + selectedImage
          }
          onClose={closeImageModal}
          id={id}
        />
      )}
      <Modal
        title={t("crime_information")}
        top
        visible={showGunaDetails}
        onOk={closeGunaViewModel}
        onCancel={closeGunaViewModel}
        width={95 + "%"}
      >
        <ViewGunaDetails
          pc_crimetitles={props.professionals?.pc_crimetitles}
          dataStates={
            Array.isArray(props?.professionals?.criminalViewList?.gunhaInfor) &&
            props?.professionals?.criminalViewList?.gunhaInfor.length > 0
              ? props?.professionals?.criminalViewList?.gunhaInfor
              : []
          }
          address={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].address
              : ""
          }
          name={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          user_details={props?.user}
          masterId={
            Array.isArray(props?.professionals?.criminalViewList?.basicInfo) &&
            props?.professionals?.criminalViewList?.basicInfo[0]
              ? props?.professionals?.criminalViewList?.basicInfo[0].id
              : ""
          }
          closeGunaViewModel={closeGunaViewModel}
          loading={gunaLoading}
        ></ViewGunaDetails>
      </Modal>
      <Modal
        title={t("preventive_action")}
        top
        visible={showPreventiveDetails}
        onOk={closepreventiveViewModel}
        onCancel={closepreventiveViewModel}
        width={95 + "%"}
      >
        <ViewPrevetiveDetails
          preventiveAction={preventiveAction}
          dataStates={
            Array.isArray(
              props.professionals?.criminalViewList?.preventiveInfo
            ) &&
            props.professionals?.criminalViewList?.preventiveInfo.length > 0
              ? props.professionals?.criminalViewList?.preventiveInfo
              : []
          }
          name={
            Array.isArray(props.professionals?.criminalViewList?.basicInfo) &&
            props.professionals?.criminalViewList?.basicInfo[0]
              ? props.professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          loading={preventiveLoading}
        ></ViewPrevetiveDetails>
      </Modal>
    </>
  );
};

export default connect()(FilterList);
